/* eslint-disable spaced-comment */
import { useEffect, useState, useRef } from 'react'
import {
  EditPicture,
  InfoCard,
  Loading,
  ActionCard,
  SearchBarComponent,
  Kanban,
  Kanban2,
} from 'components/index'
import { Icon } from 'assets/index'
import { useFetch, useStorage } from 'hooks'
import { Theme } from 'styles/Themes'
import Div, { LoadingContainer } from './style'

interface ICard {
  icon: string
  label: string
  value: number | string
  style: any
  secondary?: boolean
  quaternary?: boolean
  tertiary?: boolean
}

export const optionsLevels: any = {
  '40': 'SPECIALIST',
  '10': 'GESTOR',
  '20': 'DIRECTOR',
  '8': 'FINANCIAL',
  '4': 'LEGAL',
  '2': 'RI',
  '1': 'RH',
  '7F': 'OWNER',
  '50': 'SPECGESTOR',
}

export default function Login() {
  const data = useRef<any>({ HEADER: [], CONTRACTS: [], CONQUESTS: [] })
  const [loading, setLoading] = useState(false)
  const api = useFetch('/gestor/dashboard')
  const [kanbanData, setKanbanData] = useState<any[]>([])
  const [colaboradores] = useStorage('Colaboradores')

  useEffect(() => {
    const gList = colaboradores
    if (gList > 0) return
    setLoading(true)
    const promises: any = [
      api.fetch('get'),
      api.fetch('get', null, '/gestor/kanban/resumed_contract'),
    ]
    Promise.all(promises)
      .then((res) => {
        const [cards, kanban] = res
        console.log(kanban)
        if (kanban.fail) throw new Error(kanban.errors.message)
        if (cards.fail) throw new Error(cards.errors.message)
        setKanbanData(kanban.data.data)

        data.current = cards.data.data

        setLoading(false)
      })
      .catch((err) => {
        console.error(err)
        setLoading(false)
      })
  }, [])

  if (loading)
    return (
      <LoadingContainer>
        <Loading modal />
      </LoadingContainer>
    )
  return (
    <Div>
      <div className="user-info">
        <EditPicture name="Maria Elisa da Silva" />
      </div>

      {Object.entries(data?.current).map((item: any) => {
        return (
          <div className="section-wrapper" key={item[0]}>
            {item[0] === 'TEAMCONTRACTS' && (
              <p className="small-title">Contratos da Equipe</p>
            )}
            {item[0] === 'CONQUESTS' && (
              <p className="small-title">Minhas Conquistas</p>
            )}
            {item[0] === 'MYCONTRACTS' && (
              <p className="small-title">Meus Contratos</p>
            )}
            {item[0] === 'RENTABILITY' && (
              <p className="small-title">Pagamento de rentabilidade</p>
            )}
            {item[0] === 'COMMISSION' && (
              <p className="small-title">Pagamento de comissão</p>
            )}
            {item[0] === 'CONTRACTS' && (
              <p className="small-title">Contratos</p>
            )}
            {item[0] === 'LEGALINFO' && (
              <p className="small-title">Fluxo Jurídico</p>
            )}
            {item[0] === 'TEAM' && <p className="small-title">Equipe</p>}
            <div className="card-wrapper">
              {item[1]?.map((card: ICard) => {
                return (
                  <InfoCard
                    key={card.label}
                    value={String(card.value)}
                    secondary={card.secondary}
                    quaternary={card.quaternary}
                    tertiary={card.tertiary}
                    icon={Icon(card.icon)}
                    small
                    filter={!card.secondary && !card.quaternary}
                  >
                    {card.label}
                  </InfoCard>
                )
              })}
              {/* <div className="gray-line" />  */}
            </div>
          </div>
        )
      })}
      {/*
      Produtos
      <div className="section-wrapper product-wrapper">
        <p className="small-title">Produtos</p>
        <div className="card-wrapper">
          <ActionCard icon={Icon('planet.svg')} value="Investimentos" />
          <ActionCard icon={Icon('token.svg')} value="Token" disabled />
          <ActionCard
            icon={Icon('building.svg')}
            value="Empreendimento"
            disabled
          />
        </div>
      </div>
      */}
      {/*
      Kambam
      <div className="section-wrapper kanban-wrapper">
        <div>
          <SearchBarComponent
            dataTestId="search-document"
            width="medium"
            onChange={(e: any) => {
              console.log(e.target.value)
            }}
            placeholder="CPF / CNPJ Cliente"
          />
        </div>
        <Kanban2 investCard data={kanbanData} setData={setKanbanData} />
      </div>
       */}
    </Div>
  )
}
